import { type SetRequired, type Simplify } from 'type-fest'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type Unassigned } from '~/utils'

export const pathKey = 'timeSeriesAnalysis' satisfies PathKey

export type BrandSettingsInputBrand = {
  id?: string
  name: string
  attachedBrandMap: Record<string, Unassigned | number | null>
}

export type BrandSettingsInputBrandDefault = SetRequired<
  BrandSettingsInputBrand,
  'id'
>

export type QuestionSettingsInputQuestion = {
  id?: string
  name: string
  attachedQuestionMap: Record<string, Unassigned | string | null>
  options: {
    id?: string
    text: string
    attachedOptionMap: Record<string, Unassigned | number | null>
  }[]
  showCustomizedKPI: boolean
}

export type QuestionSettingsInputQuestionDefault = Simplify<
  SetRequired<Omit<QuestionSettingsInputQuestion, 'options'>, 'id'> & {
    options: SetRequired<
      QuestionSettingsInputQuestion['options'][number],
      'id'
    >[]
  }
>

export type CustomerAttributeGroupSettingsInputCustomerAttributeGroup = {
  id?: string
  name: string
  attachedCustomerAttributeGroupMap: Record<string, Unassigned | string | null>
  customerAttributes: {
    id?: string
    name: string
    attachedCustomerAttributeMap: Record<string, Unassigned | number | null>
  }[]
  showCustomizedKPI: boolean
}

export type CustomerAttributeGroupSettingsInputCustomerAttributeGroupDefault =
  Simplify<
    SetRequired<
      Omit<
        CustomerAttributeGroupSettingsInputCustomerAttributeGroup,
        'customerAttributes'
      >,
      'id'
    > & {
      customerAttributes: SetRequired<
        CustomerAttributeGroupSettingsInputCustomerAttributeGroup['customerAttributes'][number],
        'id'
      >[]
    }
  >
